// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"57777e47","585":"1283a89c"}[chunkId] + ".chunk.js";
};